import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
} from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useProjectDocuments } from "../../hooks/useProjectDocuments";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const VehiculosHabilitacionDashboard = () => {
  const { projectId } = useParams();
  const location = useLocation();
  const pronom = location.state?.pronom || "Nombre no disponible";
  const [search, setSearch] = useState("");
  const [pageH, setPageH] = useState(0);
  const [pageN, setPageN] = useState(0);
  const [rowsPerPageH, setRowsPerPageH] = useState(5);
  const [rowsPerPageN, setRowsPerPageN] = useState(5);

  const {
    vehiculosHabilitacion,
    isLoadingVehiculoHabilitacion,
    errorVehiculoHabilitacion,
  } = useProjectDocuments(projectId);

  const habilitados = vehiculosHabilitacion?.habilitados || [];
  const noHabilitados = vehiculosHabilitacion?.noHabilitados || [];

  const filteredH = habilitados.filter(veh =>
    veh.descripcion.toLowerCase().includes(search.toLowerCase())
  );

  const filteredN = noHabilitados.filter(veh =>
    veh.descripcion.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedH = filteredH.slice(pageH * rowsPerPageH, pageH * rowsPerPageH + rowsPerPageH);
  const paginatedN = filteredN.slice(pageN * rowsPerPageN, pageN * rowsPerPageN + rowsPerPageN);

  if (isLoadingVehiculoHabilitacion) return <Typography>Cargando vehículos...</Typography>;
  if (errorVehiculoHabilitacion) return <Typography>Error al cargar vehículos: {errorVehiculoHabilitacion.message}</Typography>;

  return (
    <Paper sx={{ p: 3, backgroundColor: "#f4f6f8", borderRadius: 2 }}>      
      <Typography variant="h5" fontWeight={700} gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <InsertDriveFileIcon color="primary" />
        Vehículos Proyecto: <span style={{ color: "#1976d2" }}>{pronom}</span>
      </Typography>

      <TextField
        fullWidth
        label="Buscar vehículo"
        variant="outlined"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPageH(0);
          setPageN(0);
        }}
        sx={{ mb: 3 }}
      />

      {/* Vehículos Habilitados */}
      <Typography variant="h6" color="success.main" gutterBottom>
        Vehículos Habilitados
      </Typography>
      <TableContainer sx={{ mb: 4 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#e0e0e0" }}>
            <TableRow>
              <TableCell><strong>Vehículo</strong></TableCell>
              <TableCell><strong>Estado</strong></TableCell>
              <TableCell><strong>Documentos Faltantes</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedH.map((veh) => (
              <TableRow key={veh.vehid} hover>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DirectionsCarIcon color="primary" />
                    {veh.descripcion}
                  </Box>
                </TableCell>
                <TableCell>
                  <Chip
                    icon={<CheckCircleIcon />}
                    label="HABILITADO"
                    color="success"
                    size="small"
                  />
                </TableCell>
                <TableCell>-</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredH.length}
          page={pageH}
          onPageChange={(e, newPage) => setPageH(newPage)}
          rowsPerPage={rowsPerPageH}
          onRowsPerPageChange={(e) => {
            setRowsPerPageH(parseInt(e.target.value, 10));
            setPageH(0);
          }}
        />
      </TableContainer>

      {/* Vehículos Inhabilitados */}
      <Typography variant="h6" color="error.main" gutterBottom>
        Vehículos Inhabilitados
      </Typography>
      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: "#e0e0e0" }}>
            <TableRow>
              <TableCell><strong>Vehículo</strong></TableCell>
              <TableCell><strong>Estado</strong></TableCell>
              <TableCell><strong>Documentos Faltantes</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedN.map((veh) => (
              <TableRow key={veh.vehid} hover>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DirectionsCarIcon color="primary" />
                    {veh.descripcion}
                  </Box>
                </TableCell>
                <TableCell>
                  <Chip
                    icon={<WarningAmberIcon />}
                    label="INHABILITADO"
                    color="error"
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  {veh.faltantes?.length > 0 ? (
                    veh.faltantes.map((doc, idx) => (
                      <Tooltip key={idx} title="Documento requerido no vigente">
                        <Chip
                          icon={<WarningAmberIcon fontSize="small" />}
                          label={doc}
                          size="small"
                          color="warning"
                          sx={{ mr: 1, mb: 0.5 }}
                        />
                      </Tooltip>
                    ))
                  ) : (
                    "-"
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredN.length}
          page={pageN}
          onPageChange={(e, newPage) => setPageN(newPage)}
          rowsPerPage={rowsPerPageN}
          onRowsPerPageChange={(e) => {
            setRowsPerPageN(parseInt(e.target.value, 10));
            setPageN(0);
          }}
        />
      </TableContainer>
    </Paper>
  );
};

export default VehiculosHabilitacionDashboard;
